
import React, { useEffect, useRef, useState, useCallback } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import Spinner from "./spinner";
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";

const ActivityDetectionFrame = React.forwardRef((props, ref) => {
    const [showSpinner, setShowSpinner] = useState(false);
    const prevContentRef = useRef({ id: props.id, src: props.src });
    const frameRef = useRef(null);
    //console.info(`XXX ActivityDetectionFrame events,props`, props.events, props);
    useEffect(() => {
        window.removeEventListener('message', listenToMessage);
        if (!props.ignoreChanges) {
            window.addEventListener('message', listenToMessage);
        }

    }, []);
 
    const listenToMessage = (evnt) =>{
        console.info(`ActivityDetectionFrame listenToMessage message ${evnt?.data?.eventName}`, evnt);
        if (evnt?.data?.eventName === "loaded") {
            postAMessage({ name: 'events', data: props.events });
        }
        if (evnt?.data?.eventName === "eventsloaded") {
            postAMessage({ name: 'observe', data: props.observe });
        }
        if (evnt?.data?.eventName === "observeloaded") {
            postAMessage({ name: 'bswMatch', data: props.bswMatch });
        }
        if (evnt?.data?.bswElement) {
            props.onMessage(evnt);
        }
        //props.onMessage(evnt);
        //props.onObserved(evnt);
    }

    useEffect(() => {
        if (prevContentRef.current.id !== props.id || prevContentRef.current.src !== props.src) {
            prevContentRef.current = { id: props.id, src: props.src };
            //setShowSpinner(true);
        }
    });



    useEffect(() => {
        //console.info(`*ActivityDetectionFrame only runs when showSpinner changes`);
    }, [showSpinner]);





    const injectScriptBlock = (sScript, sScriptURL, sType) => {
        //console.info(`ActivityDetectionFrame injectScriptBlock`);

        const frame = frameRef.current;
        if (!frame) {
            //debugger;
            return;
        }

        let doc = "";
        try { doc = frame.contentDocument; } catch (e) { }

        if (!doc) {
            //debugger;
            return;
        }
        //console.info(`ActivityDetectionFrame injectScriptBlock have doc`);

        let SecondFrame = frame.contentDocument.getElementById("frmMyChart");
        if (SecondFrame) {
            //debugger;
            //console.info(`ActivityDetectionFrame injectScriptBlock have frmMyChart`);
            let SecondDoc = null;
            try { SecondDoc = SecondFrame.contentDocument } catch (e) { }
            if (SecondDoc) {
                injectIntoDocument(SecondDoc, sScript, sScriptURL, sType);
                //doc = SecondDoc;
            }
        }

        injectIntoDocument(doc, sScript, sScriptURL, sType);


    }

    const injectIntoDocument = (doc, sScript, sScriptURL, sType) => {
        let injectTarget = null;
        //console.info(`ActivityDetectionFrame injectIntoDocument`);
        ['head', 'HEAD', 'body', 'BODY', 'div', 'DIV'].forEach(tagName => {
            if (injectTarget) return;
            const found = doc.getElementsByTagName(tagName);
            if (!(found && found.length)) return;
            injectTarget = found[0];
        });
        //console.info(`ActivityDetectionFrame injectIntoDocument injectTarget`, injectTarget);
        if (!injectTarget) {
            console.error('Unable to inject iframe resizer script');
            return;
        }
        if (!(sType === 'css')) {
            let injScriptElement = document.createElement('script');
            injScriptElement.type = 'modules';// 'text/javascript';
            if (sScriptURL) {
                injScriptElement.src = sScriptURL;
                if (sScriptURL.indexOf("Observation") > -1) {
                    injScriptElement.id = "bswActivityObservation";
                } else if (sScriptURL.indexOf("Detection") > -1) {
                    injScriptElement.id = "bswActivityDetection";
                } else if (sScriptURL.indexOf("eventHandling") > -1) {
                    injScriptElement.id = "bswEventHandling";
                }
                //console.info(`ActivityDetectionFrame injectIntoDocument injecting scriptURL ${sScriptURL}`,injScriptElement);
            }
            else if (sScript) {
                //console.info(`ActivityDetectionFrame injectIntoDocument injecting js`);
                injScriptElement.text = sScript;
            }
            //if (sBlockID) {
            //    injScriptElement.id = sBlockID;
            //    if (injectTarget.ownerDocument.getElementById(sBlockID)) {
            //        return; // already injected
            //    }
            //}

            //console.info(`ActivityDetectionFrame injectIntoDocument appending script to injectTarget`, injectTarget,injScriptElement);
            injectTarget.appendChild(injScriptElement);
        }
        else if (sType === 'css') {
            const resizerCSSElement = document.createElement("link");
            resizerCSSElement.type = "text/css";
            resizerCSSElement.rel = "stylesheet";

            if (sScriptURL) {
                resizerCSSElement.href = sScriptURL;
            }

            injectTarget.appendChild(resizerCSSElement);
        }
    }


    const onLoad = () => {
        const bswCDNScript = window.serverData.data.bswcdnScript;
        console.info(`ActivityDetectionFrame onLoad props:`, props);
        if (props.containerClass !== "hidden") {
            try { window.parent.scrollTo(0, 0); } catch (e) { }
            try { window.parent.document.body.scrollTop = 0; } catch (e) { }
            try { window.parent.document.documentElement.scrollTop = 0; } catch (e) { }
            
            if (props.additionalScripts) {

                props.additionalScripts.forEach(asURL => {
                        injectScriptBlock(null, asURL.url);
                });
            }
            if (props.additionalCSS) {
                props.additionalCSS.forEach(sURL => {
                    injectScriptBlock(null, sURL, 'css');
                });
            }
        }
        if (!props.ignoreChanges) {
            window.addEventListener('message', evnt => {
                console.info(`ActivityDetectionFrame window.addEventListener message ${evnt?.data?.eventName}`, evnt);
                if (evnt?.data?.eventName === "loaded") {
                    postAMessage({ name: 'events', data: props.events });
                }
            });
            postAMessage({ name: 'bswData', data: window.store.getState().session });
        }
        window.formChanged = false; // reset this every postback (assuming a successful submit of some kind)
        // DISABLED because it's causing a loading loop :(
        if (props.onIframeLoaded) props.onIframeLoaded(frameRef); //initCallback not getting called in case of error , so adding this back just to hide spinner

        if (showSpinner) {
            setShowSpinner(false);
        }

        if (props.onLoad) {
            props.onLoad();
        }


    }

    const postAMessage = (msg) => {
        try {
            console.info(`ActivityDetectionFrame postAMessage msg, frame`, msg);
            document.getElementById("mychartDataTile").contentWindow.postMessage(msg, "*");
        } catch (e) {
            logUI("MBHWeb.ActivityDetectionFrame.postAMessage", new Date(), Tools.getURLPath(),msg);
        }
    }

    const onReadyStateChange = () => {
        //debugger;
        if (frameRef.readyState === 0) {
            //debugger;
        }
    }

    const { src, id, frameBorder, className, style, title, border } = props;
    //console.info(`ActivityDetectionFrame id:${id} src:${src}`);
    return <React.Fragment>
        <iframe
            id={id}
            name={id}
            ref={frameRef}
            src={src}
            frameBorder={frameBorder}
            className={className}
            style={style}
            onLoad={onLoad}
            title={title ? title : ""}
            border={border}
        />

        {showSpinner &&
            <Spinner />
        }
    </React.Fragment>;

});
ActivityDetectionFrame.propTypes = {
    // iframe content/document
    // option 1. content of HTML to load in the iframe
    content: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element,
    ]),
    // option 2. src to a URL to load in the iframe
    src: PropTypes.string,
    // iframe-resizer controls and helpers
    // misc props to pass through to iframe
    id: PropTypes.string,
    frameBorder: PropTypes.number,
    className: PropTypes.string,
    style: PropTypes.object,
    additionalCSS: PropTypes.object,
    additionalScripts: PropTypes.arrayOf(PropTypes.object),
    border: PropTypes.string,
    ignoreChanges: PropTypes.bool,
    events: PropTypes.arrayOf(PropTypes.object),
    //a css selector for the dom element to be observed default is body 
    observe: PropTypes.string || PropTypes.array,
    //a css selector to fire a match event
    bswMatch: PropTypes.string || PropTypes.array,
    //Default window message 
    onMessage: PropTypes.func,
    //function to call when the observed element is triggerd
    onObserved: PropTypes.func,
    // optional extra callback when iframe is loaded
    onIframeLoaded: PropTypes.func,
};
/**
 * if any of the properties are used and the default value is still wanted then it is accumbent on the over riding componet to ensure
 * they are added.
 * */
ActivityDetectionFrame.defaultProps = {
    // resize iframe
    // misc props to pass through to iframe
    frameBorder: 0,
    style: {
        width: '100%',
        minHeight: 20,
    },
    events: [],
    additionalScripts: [],//[{ url: `${window.location.origin}/scripts/bswMyChart.js` }],// { url: `${window.serverData.data.bswcdnScript}ChildChangeObservation.js` }],
    border: "0px",
    ignoreChanges: false,
    observe: "",
    bswMatch: "",
    onMessage: (event) => { console.info(`ActivityDetectionFrame onMessage`, event) },
    onObserved: (data) => { console.info(`ActivityDetectionFrame onObserved`, data) }
};

export default withRouter(ActivityDetectionFrame);
